import React from "react";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import AddEditpage from "./addEditpage";

const CreateEstimate = () => {
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Create Sale"
            title="Main"
            subtitle="Create Sale"
            modalClass="col-auto float-end ms-auto"
          />
          <AddEditpage />
        </div>
      </div>
    </>
  );
};

export default CreateEstimate;
